// src/shared/layout/modals/ModalHeader.js
import styled from 'styled-components';

const ModalHeader = styled.div`
  padding: 1.25rem 1.5rem;
  background-color: #ffffff;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default ModalHeader;
